var _a;

import { fields, filter, fold, csvParser, dsvParser, tsvParser } from "@visactor/vdataset";

const createFactoryRegistry = () => ({
    charts: {},
    series: {},
    components: {},
    graphicComponents: {},
    marks: {},
    regions: {},
    animations: {},
    implements: {},
    chartPlugin: {},
    vChartPlugin: {},
    componentPlugin: {},
    transforms: {
        fields: fields,
        filter: filter,
        fold: fold
    },
    dataParser: {
        csv: csvParser,
        dsv: dsvParser,
        tsv: tsvParser
    },
    layout: {},
    grammarTransforms: {},
    stageEventPlugins: {},
    interactionTriggers: {},
    composedEventMap: {},
    tooltipProcessors: {},
    runtimePluginInstallers: {},
    formatter: void 0
}), factoryRegistryVersion = "2.1.3", factoryRegistryKey = Symbol.for("@visactor/vchart/factory-registry@2.1.3"), globalFactoryRegistry = globalThis;

export const factoryRegistry = null !== (_a = globalFactoryRegistry[factoryRegistryKey]) && void 0 !== _a ? _a : globalFactoryRegistry[factoryRegistryKey] = {
    charts: {},
    series: {},
    components: {},
    graphicComponents: {},
    marks: {},
    regions: {},
    animations: {},
    implements: {},
    chartPlugin: {},
    vChartPlugin: {},
    componentPlugin: {},
    transforms: {
        fields: fields,
        filter: filter,
        fold: fold
    },
    dataParser: {
        csv: csvParser,
        dsv: dsvParser,
        tsv: tsvParser
    },
    layout: {},
    grammarTransforms: {},
    stageEventPlugins: {},
    interactionTriggers: {},
    composedEventMap: {},
    tooltipProcessors: {},
    runtimePluginInstallers: {},
    formatter: void 0
};
//# sourceMappingURL=factory-registry.js.map
